import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultTargetMonth } from '@/features/contract-and-cost/targetMonth';
export const Route = createFileRoute('/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/')({
  beforeLoad: () => {
    throw redirect({
      to: '/devices/contract-and-cost/payment/$targetMonth',
      params: {
        targetMonth: getDefaultTargetMonth()
      }
    });
  }
});